var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29495 24.6825C5.00795 19.5345 4.36445 16.962 5.71595 15.231C7.06595 13.5 9.72095 13.5 15.0265 13.5H21.9714C27.2784 13.5 29.9304 13.5 31.2819 15.231C32.6334 16.9605 31.9899 19.536 30.7029 24.6825C29.8839 27.957 29.4759 29.5935 28.2549 30.5475C27.0339 31.5 25.3464 31.5 21.9714 31.5H15.0265C11.6515 31.5 9.96395 31.5 8.74295 30.5475C7.52195 29.5935 7.11245 27.957 6.29495 24.6825Z",
    stroke: "#D89513",
    strokeWidth: 2.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 14.25L28.685 10.3425C28.274 8.835 28.0685 8.082 27.647 7.5135C27.2267 6.9487 26.656 6.5136 26 6.258C25.34 6 24.56 6 23 6M7.25 14.25L8.315 10.3425C8.726 8.835 8.9315 8.082 9.353 7.5135C9.77327 6.9487 10.344 6.5136 11 6.258C11.66 6 12.44 6 14 6",
    stroke: "#D89513",
    strokeWidth: 2.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6C14 5.60218 14.158 5.22064 14.4393 4.93934C14.7206 4.65804 15.1022 4.5 15.5 4.5H21.5C21.8978 4.5 22.2794 4.65804 22.5607 4.93934C22.842 5.22064 23 5.60218 23 6C23 6.39782 22.842 6.77936 22.5607 7.06066C22.2794 7.34196 21.8978 7.5 21.5 7.5H15.5C15.1022 7.5 14.7206 7.34196 14.4393 7.06066C14.158 6.77936 14 6.39782 14 6Z",
    stroke: "#D89513",
    strokeWidth: 2.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.461d696d29ba55db453372bab6d74656.svg";
export { ForwardRef as ReactComponent };